import { siteStats } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20artistic%20watercolor%20illustration%20blending%20elegant%20mature%20woman%20silhouette%20with%20flowing%20ink%20brush%20strokes%20and%20soft%20manga%20panel%20collage%2C%20muted%20rose%20amber%20and%20cream%20tones%2C%20dreamy%20atmospheric%20composition%2C%20tasteful%20graceful%20editorial%20poster%20art%2C%20soft%20film%20grain%2C%20high%20detail&width=1920&height=1200&seq=gm-hero-2026-01&orientation=landscape"
          alt="以水彩与水墨笔触表现的成熟女性剪影与漫画分镜拼贴，营造柔和暖调氛围"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 pt-28 pb-14 md:pt-36 md:pb-20">
        <div className="max-w-6xl mx-auto">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 text-background-50 text-xs md:text-sm border border-background-50/25 backdrop-blur-sm">
            <i className="ri-quill-pen-line"></i>
            同人漫画 · 插画 · 本子合集导览
          </span>

          <h1 className="mt-5 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight max-w-4xl">
            女友的妈妈：同人漫画、插画与岳母题材合集
          </h1>

          <p className="mt-5 text-base md:text-lg text-background-100/90 max-w-2xl leading-relaxed">
            这里汇总“女友的妈妈”题材的同人漫画与插画资源，按画风与剧情设定分门别类。
            无论你偏好轻松搞笑的日常，还是暗黑悬疑的张力，都能先在这里锁定方向，再决定读什么。
          </p>

          <div className="mt-8 flex flex-col sm:flex-row gap-3">
            <a
              href="#works"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-bookmark-3-line"></i>
              浏览作品合集
            </a>
            <a
              href="#styles"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-background-50/10 text-background-50 text-sm md:text-base font-medium border border-background-50/35 hover:bg-background-50/20 transition-colors whitespace-nowrap backdrop-blur-sm"
            >
              <i className="ri-palette-line"></i>
              查看画风图鉴
            </a>
          </div>

          <dl className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl">
            {siteStats.map((s) => (
              <div
                key={s.label}
                className="border-l-2 border-accent-500/70 pl-4"
              >
                <dt className="sr-only">{s.label}</dt>
                <dd>
                  <span className="font-heading text-2xl md:text-4xl font-bold text-background-50">
                    {s.value}
                  </span>
                  <span className="ml-1 text-xs md:text-sm text-background-100/80">
                    {s.unit}
                  </span>
                  <p className="mt-1 text-xs md:text-sm text-background-100/70">
                    {s.label}
                  </p>
                </dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}